import { Component, OnInit, ViewChild } from '@angular/core';
import { RoleFormComponent } from 'app/components/role-form/role-form.component';
import { Entity } from 'app/pages/product/product.model';
import { SystemService } from 'app/services/system.service';
import {TeamFormComponent} from '../../../components/team-form/team-form.component';
import {EntityListComponent} from '../../../components/entity-list/entity-list.component';
import {Team} from '../../../components/team-form/team.model';
import {Role} from '../../../components/role-form/role.model';

@Component({
  selector: 'app-role-page',
  templateUrl: './role-page.component.html',
  styleUrls: ['./role-page.component.scss']
})
export class RolePageComponent implements OnInit {


    @ViewChild('entityList')
    entityList: EntityListComponent;

    roles: Entity[];

    @ViewChild('roleForm')
    roleForm: RoleFormComponent;
    role: Role;


    constructor(public _systemService: SystemService) {
        
    }

    selected(entity: any): void{
        this.role = entity;
        this.roleForm.selected(entity);
    }

    ngOnInit(): void {
        this.roles = this._systemService.roles;
    }

    entityChanged(role: any): void{
        const activityIndex = this.roles.indexOf(this.role);
        this.roles.splice(activityIndex, 1);
        this.roles.push(role);
        this.roles.sort(
            (a, b) => a.name > b.name ? 1 : -1
            );
    }

    newRole(): void{
        this.role = new Role();
        this.entityList.deselectAll();
        this.selected(this.role);
    }

}
